import React from 'react';

import styled from 'styled-components';

import Modal from 'components/lib/Modal';

import CommunityAdminActions from './CommunityAdminActions';
import CommunityCreateContentCompany from './CommunityAdminContentCompany';
import CommunityAdminContentCompetitors from './CommunityAdminContentCompetitors';
import CommunityAdminContentInfo from './CommunityAdminContentInfo';
import { useCommunityAdminContext } from './CommunityAdminContextProvider';
import CommunityAdminHeader from './CommunityAdminHeader';
import { COMMUNITY_CREATE_MODAL_HEIGHT_FACTOR } from './constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const Panel = styled.div`
  display: flex;
  overflow-y: hidden;
`;

const CommunityAdminContent = () => {
  const { open, handleCancel } = useCommunityAdminContext();

  return (
    <Modal
      className={'flat'}
      title={<CommunityAdminHeader />}
      footer={<CommunityAdminActions />}
      open={open}
      centered
      width={'fit-content'}
      destroyOnClose
      onCancel={handleCancel}
    >
      <Container>
        <CommunityCreateContentCompany />
        <Panel style={{ height: window.innerHeight * COMMUNITY_CREATE_MODAL_HEIGHT_FACTOR }}>
          <CommunityAdminContentInfo />
          <CommunityAdminContentCompetitors />
        </Panel>
      </Container>
    </Modal>
  );
};

export default CommunityAdminContent;
